import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from '@reduxjs/toolkit';
import axios from 'axios';
import _ from '@lodash';

export const getLabels = createAsyncThunk(
  'calendarApp/labels/getLabels',
  async (categoryName = null) => {
    const response = await axios.get('/api/statusesTypes', {
      params: { category: categoryName || 'shipment_status' },
    });
    const data = await response.data.data;
    const updatedData = data?.map((item) => {
      item.checked = item.name === "Overdue" || item.name === "Upcoming" || item.name === "Priority";
      return item
    })
    return updatedData;
  }
);

export const addLabel = createAsyncThunk(
  'calendarApp/labels/addLabel',

  async (newLabel, { dispatch }) => {
    const response = await axios.post('/api/statusesTypes', {
      name: newLabel,
      title: newLabel,
      category: 'shipment_status',
    });
    const data = await response.data;

    return data;
  }
);

export const updateLabel = createAsyncThunk(
  'calendarApp/labels/updateLabel',
  async (label, { dispatch }) => {
    const response = await axios.put(`/api/statusesTypes/${label.id}`, {
      name: label,
      title: label,
    });
    const data = await response.data;

    return data;
  }
);

export const removeLabel = createAsyncThunk(
  'calendarApp/labels/removeLabel',
  async (labelId, { dispatch }) => {
    const response = await axios.delete(`/api/statusesTypes/${labelId}`);
    const data = await response.data;

    return data;
  }
);

const labelsAdapter = createEntityAdapter({});

export const {
  selectAll: selectLabels,
  selectIds: selectLabelIds,
  selectById: selectLabelById,
} = labelsAdapter.getSelectors((state) => state.calendarApp.labels);

const labelsSlice = createSlice({
  name: 'calendarApp/labels',
  initialState: labelsAdapter.getInitialState({
    selectedLabels: [],
    labelsDialogOpen: false,
    searchOrderNo: null,
  }),
  reducers: {
    toggleSelectedLabels: (state, action) => {
      state.selectedLabels = action.payload;
    },
    openLabelsDialog: (state, action) => {
      state.labelsDialogOpen = true;
    },
    closeLabelsDialog: (state, action) => {
      state.labelsDialogOpen = false;
    },
    setSearchOrderNo: (state, action) => {
      state.searchOrderNo = action.payload;
    },
  },
  extraReducers: {
    [getLabels.fulfilled]: (state, action) => {
      labelsAdapter.setAll(state, action.payload);
      state.selectedLabels = action.payload;
    },
    [addLabel.fulfilled]: labelsAdapter.addOne,
    [updateLabel.fulfilled]: labelsAdapter.upsertOne,
    [removeLabel.fulfilled]: labelsAdapter.removeOne,
  },
});

export const selectSelectedLabels = ({ calendarApp }) =>
  calendarApp.labels.selectedLabels;
export const selectFirstLabelId = ({ calendarApp }) =>
  calendarApp.labels.ids[0];
export const selectLabelsDialogOpen = ({ calendarApp }) =>
  calendarApp.labels.labelsDialogOpen;
export const selectSearchOrderNo = ({ calendarApp }) =>
  calendarApp.labels.searchOrderNo;

export const { toggleSelectedLabels, openLabelsDialog, closeLabelsDialog, setSearchOrderNo } =
  labelsSlice.actions;

export default labelsSlice.reducer;
